import type { ReactToLit } from '@affine/component';
import { AttachmentEmbedPreview } from '@affine/core/blocksuite/attachment-viewer/attachment-embed-preview';
import { isHtmlAttachment } from '@affine/core/modules/media/utils';
import {
  type AttachmentEmbedConfig,
  AttachmentEmbedConfigIdentifier,
} from '@blocksuite/affine/blocks/attachment';
import {
  EMBED_CARD_HEIGHT,
  EMBED_CARD_WIDTH,
} from '@blocksuite/affine/shared/consts';
import { Bound } from '@blocksuite/global/gfx';
import type { ExtensionType } from '@blocksuite/store';

export function patchForHtmlAttachmentEmbedView(
  reactToLit: ReactToLit
): ExtensionType {
  return {
    setup: di => {
      di.addImpl(AttachmentEmbedConfigIdentifier('html'), () => {
        const config: AttachmentEmbedConfig = {
          name: 'html',
          shouldShowStatus: true,
          check: (model, maxFileSize) =>
            isHtmlAttachment(model) && model.props.size <= maxFileSize,
          action: model => {
            const bound = Bound.deserialize(model.props.xywh);
            bound.w = EMBED_CARD_WIDTH.html;
            bound.h = EMBED_CARD_HEIGHT.html;
            model.store.updateBlock(model, {
              embed: true,
              style: 'html',
              xywh: bound.serialize(),
            });
          },
          render: model =>
            reactToLit(<AttachmentEmbedPreview model={model} />, true),
        };

        return config;
      });
    },
  };
}
